// Subscription plan names carry their billing period in the name (e.g. "Gold Monthly", "Gold Yearly").
// These helpers classify a free-text plan name into a billing period so we can tell whether an artist
// offers both a monthly and a yearly plan.

export const isMonthlyPlan = (plan: string): boolean => /month/i.test(plan)

export const isYearlyPlan = (plan: string): boolean => /year|annual/i.test(plan)

// True when the set of plans contains at least one monthly plan and at least one yearly plan.
export const hasBothPlanTypes = (plans: readonly { plan: string }[]): boolean =>
  plans.some((p) => isMonthlyPlan(p.plan)) && plans.some((p) => isYearlyPlan(p.plan))
